module.exports = __webpack_public_path__ + "img/newsdetails8.37ebba5f.png";